/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Faraz Ozair",
  title: "Hi all, I'm Faraz",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native / Supabase and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1oKniGkYjd9IVQcQ3cJ_XhyNI9Whpot3s/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/FarazOzair1999",
  linkedin: "https://www.linkedin.com/in/muhammadfarazozair/",
  gmail: "farazozair@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Enhanced Security Measures for Mobile Applications"),
    emoji(
      "⚡ Integration of third party services such as Firebase / AWS / Supabase / Stripe / Polar"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React Native",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Habib University",
      logo: require("./assets/images/habibLogo.jpeg"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "August 2018 - May 2022",
      desc: "Completed Bachelor of Science in Computer Science with a GPA of 3.2/4.0",
      descBullets: [
        "I was part of the Google Developer Students Club at Habib University.",
        "I worked as the Sponsorship team member for the Habib University Artificial Intelligence Club.",
        "As part of the mandatory voluntary work we have to do in the university, I built a Donation Management System for one of the most pretigious NGOs in Pakistan."
      ]
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "50%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Mobile Developer",
      company: "SkipCash",
      companylogo: require("./assets/images/skipcashlogo.png"),
      date: "January 2025 – Present",
      desc: "I am a Senior Mobile Developer at SkipCash. I am responsible for the development and security of the SkipCash mobile application.",
      descBullets: [
        "Implemented a SoftPOS solution using NFC with geofencing, allowing smartphones to accept contactless payments within designated areas, enhancing transaction security and compliance.",
        "Developed a dynamic Reports module with Excel export, offloading backend processing and improving system performance.",
        "Integrated Over-the-Air (OTA) updates and automated crash reporting, significantly enhancing release efficiency and app reliability.",
        "Developed secure mobile apps with fintech integrations, following PCI DSS compliance and best practices.",
        "Used Google Pay to build our own payment gateway, allowing users to pay for their purchases using their Google Pay account.",
      ]
    },
    {
      role: "Software Engineer",
      company: "Techlogix",
      companylogo: require("./assets/images/techlogixLogo.jpeg"),
      date: "Feb 2024 – Dec 2024",
      desc: "I was a Software Engineer at Techlogix. I was responsible for the development and maintenance of the Techlogix website and mobile application.",
      descBullets: [
        "Developing and maintaining responsive web applications using Angular at Techlogix, focusing on dynamic UI components and performance optimization.",
        "Collaborating on mobile application development for both Android (Java) and iOS (Swift), ensuring seamless integration with web services and APIs across platforms.",
        "Leading cross-functional efforts to bridge front-end Angular solutions with backend services, enhancing user experiences across web and mobile platforms.",
      ]
    },
    {
      role: "Software Engineer - Mobile",
      company: "Dastgyr Technologies",
      companylogo: require("./assets/images/dastgyrLogo.png"),
      date: "Jul 2022 – Jan 2024",
      desc: "I was a Mobile Developer at Dastgyr Technologies. I was responsible for the development and maintenance of the Dastgyr Technologies mobile application.",
      descBullets: [
        "Built a dynamic software to take surveys according to user preferences, basically a smart survey system to gather insights from customers automatically and uploaded to NPM website with 300+ monthly downloads and collecting user data from over 1000+ app users monthly",
        "Improved app performance by implementing redux, reducing prop drilling, avoiding unnecessary views to display huge lists.",
        "Trained a Deep Neural Network to validate CNICs on upload during the sign-up event. Using Faster RCNN and SSD MobileNet V2.",
        "Implemented the wallets feature to show debit and credit transactions in multiple applications and published a private NPM package for the company.",
        "Used MoEngage Hooks for tracking customer engagement inside the app and sending push notifications to the users."
      ]
    },
    {
      role: "Junior Software Engineer",
      company: "Avialdo Solutions",
      companylogo: require("./assets/images/avialdoLogo.png"),
      date: "Feb 2022 – Jul 2022",
      desc: "I was responsible for the development and maintenance of the Avialdo Solutions web application and backend services which were built on Python.",
      descBullets: [
        "Introduced and developed 3 new features to the website which were bulk upload, complaint routing and feedback form optimizations.",
        "Learned to develop and work with 30+ client websites and shifted them to cloudflare for better security and website management.",
        "Developed a strong skill set in building CRMs (Customer Relationship Management systems) to streamline business processes and enhance customer engagement.",
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/retailify.jpeg"),
      projectName: "Retailify Technologies Global",
      projectDesc: "Built a Clinic Management System for a startup in Pakistan.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://retailify.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3043543715",
  email_address: "farazozair@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
